import styles from "./styles.module.css";
import { useState, useEffect } from "react";

export default function SelectChild({ children, onChange, condition }) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (condition.element) {
      setValue(condition.element);
    } else {
      setValue("");
    }
  }, [condition]);
  const handleSelect = (v) => {
    const _condition = { ...condition };
    _condition.element = v;
    onChange(_condition);
  };
  return (
    <div>
      <div className={styles.propTitle}>Apply to Child Element (optional)</div>
      <select
        value={value}
        onChange={(e) => handleSelect(e.target.value)}
        className={"dropdown"}
      >
        <option value={""}></option>
        {children.map((c) => {
          return <option value={c.id}>{c.name}</option>;
        })}
      </select>
    </div>
  );
}
